import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Container from 'components/Container';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';

import 'react-image-lightbox/style.css';
import 'react-lazy-load-image-component/src/effects/blur.css';

const TrailBlazerWinners2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')
      .then((response) => response.json())
      .then((data) => setConfig(data))
      .catch((error) => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2025}/home/home-static/static-images/TrailBlazers2025/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/home-static/static-images/TrailBlazers2025/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/home-static/static-images/TrailBlazers2025/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/home-static/static-images/TrailBlazers2025/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/home-static/static-images/TrailBlazers2025/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/home-static/static-images/TrailBlazers2025/6.webp`;
  const p7 = `${config.base_image_url_2025}/home/home-static/static-images/TrailBlazers2025/7.webp`;
 const p8 = `${config.base_image_url_2025}/home/home-static/static-images/TrailBlazers2025/8.webp`;
  const p9 = `${config.base_image_url_2025}/home/home-static/static-images/TrailBlazers2025/9.webp`;

  
  const photos = [
    { src: p1, rows: 1, cols: 1 },
    { src: p2, rows: 1, cols: 1 },
    { src: p3, rows: 1, cols: 1 },
    { src: p4, rows: 1, cols: 1 },
    { src: p5, rows: 1, cols: 1 },
    { src: p6, rows: 1, cols: 1 },
    { src: p7, rows: 1, cols: 1 },
    { src: p8, rows: 1, cols: 1 },
    { src: p9, rows: 1, cols: 1 },

  ];

  return (
    <Main>
      <Container maxWidth="lg">
        <Box mb={4}>
          <Typography variant="h2" align="center">
            Winners - 2025-26
          </Typography>
          <br />
          <Typography
            variant="subtitle1"
            align="justify"
            sx={{ maxWidth: 900, mx: 'auto', lineHeight: 1.6 }}
          >
            {/* Optional descriptive text can go here if needed */}
          </Typography>
        </Box>

        <Box>
          <ImageList
            variant="quilted"
            cols={2}
            rowHeight={isMd ? 300 : 200}
            gap={isMd ? 16 : 6}
          >
            {photos.map((item, i) => (
              <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                <LazyLoadImage
                  height="100%"
                  width="100%"
                  src={item.src}
                  alt={`Trailblazer Winner ${i + 1}`}
                  effect="blur"
                  onClick={() => openLightbox(i)}
                  style={{
                    objectFit: 'cover',
                    cursor: 'pointer', // Fixed typo
                    filter: theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  }}
                />
              </ImageListItem>
            ))}
          </ImageList>
        </Box>

        {viewerIsOpen && (
          <Lightbox
            mainSrc={photos[currentImage].src}
            nextSrc={photos[(currentImage + 1) % photos.length].src}
            prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
            onCloseRequest={closeLightbox}
            onMovePrevRequest={() =>
              setCurrentImage((currentImage + photos.length - 1) % photos.length)
            }
            onMoveNextRequest={() =>
              setCurrentImage((currentImage + 1) % photos.length)
            }
            reactModalStyle={{ overlay: { zIndex: 1500 } }}
          />
        )}
      </Container>
    </Main>
  );
};

export default TrailBlazerWinners2025;
